<!-- 报表下载 -->
<template>
  <div class="app-container">
    <div class="app-content">
      <el-card
        class="table-wrap"
        shadow="never"
        body-style="{ height: calc(100vh - 60px - 40px - 32px - 40px)}"
      >
        <div class="main-content column-flex">
          <div class="search-form">
            <el-form label-width="90px">
              <el-row :gutter="15">
                <el-col :span="5">
                  <el-form-item :label="$t('text.lb')">
                    <el-button-group>
                      <el-button
                        :type="dateType === 'day' ? 'primary' : ''"
                        @click="dateType = 'day'"
                      >{{ $t('text.r') }}</el-button>
                      <el-button
                        :type="dateType === 'month' ? 'primary' : ''"
                        @click="dateType = 'month'"
                      >{{ $t('text.y') }}</el-button>
                      <el-button
                        :type="dateType === 'year' ? 'primary' : ''"
                        @click="dateType = 'year'"
                      >{{ $t('text.n') }}</el-button>
                    </el-button-group>
                  </el-form-item>
                </el-col>
                <el-col v-if="dateType==='day'" :span="4">
                  <el-form-item :label="$t('text.sjjg')">
                    <el-select
                      v-model="split"
                    >
                      <el-option
                        v-for="(item, index) in splits"
                        :key="index"
                        :label="item"
                        :value="item"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item v-show="dateType !== 'total'" :label="$t('text.shijian')">
                    <el-date-picker
                      v-show="dateType === 'day'"
                      v-model="time"
                      type="date"
                      @keyup.enter.native="handleQuery"
                    />
                    <el-date-picker
                      v-show="dateType === 'month'"
                      v-model="time"
                      type="month"
                      @keyup.enter.native="handleQuery"
                    />
                    <el-date-picker
                      v-show="dateType === 'year'"
                      v-model="time"
                      type="year"
                      @keyup.enter.native="handleQuery"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('text.sbid')">
                    <el-select
                      v-model="devid"
                      :placeholder="$t('placeholder.xzid')"
                    >
                      <el-option
                        v-for="(item, index) in deviceList"
                        :key="index"
                        :label="item.key"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-button
                    icon="el-icon-video-play"
                    type="primary"
                    @click="handleQuery"
                  >{{ $t('button.yl') }}</el-button>
                  <el-button
                    icon="el-icon-download"
                    type="warning"
                    @click="handleExport"
                  >{{ $t('button.dc') }}</el-button>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div v-if="dateType==='day'" class="table">
            <el-table :data="tableData.details">
              <el-table-column :label="$t('text.dbmc')" prop="alias" align="center" />
              <el-table-column :label="$t('text.dbxlh')" prop="sn" align="center" />
              <el-table-column :label="$t('text.dy')" prop="u" align="center" />
              <el-table-column :label="$t('text.dianliu')" prop="i" align="center" />
              <el-table-column :label="$t('text.gonglv')" prop="pac" align="center" />
              <el-table-column :label="$t('text.shijian')" prop="time" align="center" :formatter="formatTime" />
              <el-table-column :label="$t('text.zongdl')" prop="etotal" align="center" />
            </el-table>
          </div>
          <div v-if="dateType==='month'||dateType==='year'" class="table">
            <el-table :data="tableData.details">
              <el-table-column :label="$t('text.shijian')" prop="time" align="center" :formatter="formatTime" />
              <el-table-column :label="$t('text.zongdl')" prop="etotal" align="center" />
            </el-table>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { GetDevicesByOrgId } from '@/api/Universal'
import { GetAusMeterReportData, ExpAusMeterReport } from '@/api/Meter'
import { getMonthLength } from '@utils'
export default {
  components: {},
  data () {
    return {
      fullLoading: null,
      dateType: 'day',
      queryParams: {},
      tableData: {},
      report: false,
      deviceList: [],
      devid: '',
      time: this.$parseTime(new Date(), 'yyyy-MM-dd'),
      split: '60',
      splits: [5, 60]
    }
  },
  computed: {

  },
  watch: {
    dateType () {
      this.report = false
      this.tableData = {}
    },
  },
  created () {
    this.getdeviceId(() => {
      this.handleQuery()
    })
  },
  methods: {
    getdeviceId (callback) {
      GetDevicesByOrgId({ id: this.$store.getters.station.id, tag: '3' }).then((res) => {
        this.deviceList = res.data || []
        this.devid = this.deviceList[0].value || null
        if (callback) {
          callback()
        }
      })
    },
    // 预览
    handleQuery () {
      this.fullLoading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      let mask1 = ''
      let mask2 = ''
      if (this.dateType === 'day') {
        mask1 = 'yyyy-MM-dd 00:00:00'
        mask2 = 'yyyy-MM-dd 23:59:59'
      } else if (this.dateType === 'month') {
        const l = getMonthLength(this.time)
        mask1 = 'yyyy-MM-01 00:00:00'
        mask2 = 'yyyy-MM-' + l + ' 23:59:59'
      } else if (this.dateType === 'year') {
        mask1 = 'yyyy-01-01 00:00:00'
        mask2 = 'yyyy-12-31 23:59:59'
      }
      GetAusMeterReportData({
        dateType: this.dateType,
        split: this.split,
        startTime: this.$parseTime(this.time, mask1),
        endTime: this.$parseTime(this.time, mask2),
        orgId: this.$store.getters.station.id,
        deviceId: this.devid
      })
        .then((res) => {
          this.report = true
          this.fullLoading.close()
          this.tableData = res.data || []
        })
        .catch(() => {
          this.fullLoading.close()
        })
    },
    formatTime (row, column, cellValue) {
      return this.$parseTime(cellValue, 'dd-MM-yyyy hh:mm:ss')
    },
    // 导出
    handleExport () {
      this.fullLoading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let mask1 = ''
      let mask2 = ''
      if (this.dateType === 'day') {
        mask1 = 'yyyy-MM-dd 00:00:00'
        mask2 = 'yyyy-MM-dd 23:59:59'
      } else if (this.dateType === 'month') {
        const l = getMonthLength(this.time)
        mask1 = 'yyyy-MM-01 00:00:00'
        mask2 = 'yyyy-MM-' + l + ' 23:59:59'
      } else if (this.dateType === 'year') {
        mask1 = 'yyyy-01-01 00:00:00'
        mask2 = 'yyyy-12-31 23:59:59'
      }
      ExpAusMeterReport({
        dateType: this.dateType,
        split: this.split,
        startTime: this.$parseTime(this.time, mask1),
        endTime: this.$parseTime(this.time, mask2),
        orgId: this.$store.getters.station.id,
        deviceId: this.devid
      })
        .then(res => {
          this.fullLoading.close()
          window.location.href = res.data
        })
        .catch(() => {
          this.fullLoading.close()
        })
    }
  },
}
</script>
<style lang='stylus' scoped>
.app-container {
  margin-right: 5px;
  padding: 10px;
  background-color: #F8F8F8;
}

.el-input + .el-input {
  margin-top: 0;
}

.el-form-item.total ::v-deep label {
  cursor: not-allowed;
  color: #ccc;
}

.search-form {
  height: 60px;
}

.main-content {
  height: calc(100vh - 60px - 40px - 32px - 40px);
}

.table {
  height: calc(100% - 60px);
  overflow-y: auto;
}

</style>

